import React from 'react';

import Masthead from '@zola/zola-ui/src/components/PreAuthV3/Masthead';

import { PageTypes } from 'libs/contentful/types';

import { EA_PATH } from 'constants/expertAdvice';

import { DESKTOP_MIN, TABLET_MIN } from '@zola-helpers/client/dist/es/util/responsive';
import { FeaturedArticleContainer, AltMedia, AltMediaWrapper } from './FeaturedArticle.styles';

type FeaturedArticleProps = {
  featuredArticle?: PageTypes;
};

const FeaturedArticle = ({ featuredArticle }: FeaturedArticleProps): JSX.Element => {
  const { excerpt, heroImage, slug = '', title } = featuredArticle || {};
  const { altText = '', src = '' } = heroImage || {};

  return featuredArticle ? (
    <FeaturedArticleContainer>
      <Masthead
        asLink
        btnHref={`${EA_PATH}/${slug}`}
        content={excerpt}
        title={title}
        altMedia={
          <AltMediaWrapper>
            <AltMedia
              alt={altText}
              breakpointWidthMap={{ 1: 380, [TABLET_MIN]: 480, [DESKTOP_MIN]: 920 }}
              src={src}
              loading="eager"
            />
          </AltMediaWrapper>
        }
      />
    </FeaturedArticleContainer>
  ) : (
    <></>
  );
};

export default FeaturedArticle;
